<template>
   <div class="background customer-banner  justify-content-center ">
      <div class="container container-1200 map-bg">
         <div class="row">
            <div class=" col-md-12 col-lg-12 text-center">
               <div class="inner-container">
                  <h1 class="text-white">{{ config.header }}</h1>
                  <div class="form-group custom-dropdown">
                     <select v-model="selectedData"
                             class="form-control custom-select-box">
                        <option v-for="(item, index) in selectionData"
                                :key="index"
                                :value="item">
                           {{ item }}
                        </option>
                     </select>
                     <span class="down-icon">
                        <i class="fc_dropdown" />
                     </span>
                  </div>
                  <div>
<div v-if="isClient"
                          class="row">
                        <div class="col-12">
                           <div :ref="sliderConfig.name"
                                v-swiper="swiperOption"
                                style="overflow:hidden">
<div v-if="sliderData.length <= 11"
                                   class="swiper-wrapper small">
                                 <div v-for="(item, index) in sliderData"
                                      :key="index"
                                      class="swiper-slide">
                                    <div class="svg logo-container text-center">
                                       <div class="card">
                                          <div class="card-header p-0 m-0">
                                             <div :class="`${item.logo} custom-header-img`" />
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>

                              <div v-if="sliderData.length > 11"
                                   class="swiper-wrapper large">
                                 <div v-for="(item, index) in sliderData"
                                      v-if="index % 2 === 0"
                                      :key="index"
                                      class="swiper-slide">
                                    <div class="svg logo-container text-center">
                                       <div class="card">
                                          <div class="card-header p-0 m-0">
                                             <div :class="`${item['logo']} custom-header-img`" />
                                          </div>
                                       </div>
                                       <div v-if="sliderData[index + 1]"
                                            class="card">
                                          <div class="card-header p-0 m-0">
                                             <div :class="`${sliderData[index+1]['logo']} custom-header-img`" />
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
</div>
                           <div v-show="sliderData.length > 6 && sliderData.length < 12  || sliderData.length > 12 "
                                slot="pagination"
                                class="swiper-pagination" />

                           <div slot="button-prev"
                                class="swiper-button-prev">
                              <i class="fc_keyboard_arrow_left circular-button" />
                           </div>

                           <div slot="button-next"
                                class="swiper-button-next">
                              <i class="fc_keyboard_arrow_right circular-button" />
                           </div>
</div>
                     </div>
                  </div>
</div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'CustomerBanner',
   props: {
      config: {
         type: Object,
         default: () => ({}),
      },
      customerData: {
         type: Object,
         default: () => ({}),
      },
   },
   data: () => ({
      isClient: false,
      selectedData: 'IT, Software & Services',
      data: [],

      sliderConfig: {
         name: 'customerSwipper',
         pagination: true,
         btnPrev: true,
         btnNext: true,
         scrollbar: false,
         transparentBg: false,
      },

      swiperOption: {
         slidesPerView: 6,
         spaceBetween: 5,
         slidesPerGroup: 6,
         freeMode: true,
         pagination: {
            el: '.swiper-pagination',
            clickable: true,
         },
         navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
         },
         breakpoints: {
            1200: {
               slidesPerView: 5,
               spaceBetween: 5,
               slidesPerGroup: 5,
            },
            992: {
               slidesPerView: 5,
               spaceBetween: 5,
               slidesPerGroup: 5,
            },
            768: {
               slidesPerView: 4,
               spaceBetween: 5,
               slidesPerGroup: 4,
            },
            640: {
               slidesPerView: 3,
               spaceBetween: 3,
               slidesPerGroup: 3,
            },
            480: {
               slidesPerView: 2,
               spaceBetween: 2,
               slidesPerGroup: 2,
            },
            390: {
               slidesPerView: 1,
               spaceBetween: 0,
               slidesPerGroup: 1,
            },
         },
      },
   }),

   computed: {
      sliderData() {
         return this.data.filter(item => !item.filter);
      },
      selectionData() {
         return Object.keys(this.customerData).sort();
      },
   },
   watch: {
      selectedData(value) {
         this.slideTofirst();
         const selectedValue = value.trim();
         for (let i = 0; i < this.data.length; i++) {
            if (this.data[i].group !== selectedValue) {
               this.data[i].filter = true;
            } else {
               this.data[i].filter = false;
            }
         }
      },
   },
   created() {
      // data preparations
      this.dataPreparation();
   },
   mounted() {
      this.isClient = true;
   },
   methods: {
      dataPreparation() {
         const customers = this.customerData;
         Object.keys(customers).forEach(key => {
            const items = customers[key];
            items.forEach(item => {
               const getLogokey = logo =>
                  `cutomer-logo-${logo
                     .toLowerCase()
                     .replace(/[&',-.]/gi, '-')
                     .split(' ')
                     .join('-')}`;

               this.data.push({
                  group: key,
                  filter: key !== 'IT, Software & Services',
                  logo: getLogokey(item),
               });
            });
         });
      },

      slideTofirst() {
         this.swiper.slideTo(0, 0);
         // console.log(this.swiper.isBeginning);
      },
   },
};
</script>

<style lang="scss" scoped>
.customer-banner {
   position: relative;
   background: linear-gradient(
      150.48deg,
      #22166a 0%,
      rgba(145, 64, 134, 0.99) 54.33%,
      #ecd4a0 100%
   );
   background-size: cover;

   .inner-container {
      padding-top: 65px;
      color: #fff;
   }

   .map-bg {
      background: url('/public/images/Map.svg');
      background-repeat: no-repeat;
      background-size: auto;
      background-position: bottom;
      min-height: 484px;
   }

   .custom-dropdown {
      padding-top: 24px;
      padding-bottom: 53px;
      margin: 0 !important;
      display: inline-block;
   }

   .card {
      padding: 10px;
      background-color: #fff;
      display: block;
      max-width: 166px;
      min-height: 71px;
      margin: 0 auto 20px !important;
   }

   .custom-header-img {
      width: auto;
      height: 91px;
      transform: scale(0.6);
      margin-left: -10px;
   }

   .custom-select-box {
      box-sizing: border-box;
      border-radius: 4px;
      box-shadow: 0 8px 10px 0 rgba(62, 57, 107, 0.04);
      background-image: none;
      overflow: hidden;
      position: relative;
      /*hide default down arrow in webkit */
      -webkit-appearance: none;
   }

   .custom-select-box,
   .custom-select-box select {
      width: auto;
      padding-right: 2.8rem;
   }
   select:focus {
      outline: none;
   }
   .custom-select-box select {
      height: 34px;
      padding: 5px 0 5px 5px;
      background: transparent;
      border: none;
   }

   select::-ms-expand {
      display: none;
   } /* hide default down arrow in IE10*/

   /* hack to fall back in opera */
   _:-o-prefocus,
   .selector {
      .custom-select-box {
         background: none;
      }
   }

   .down-icon {
      position: absolute;
      top: 38px;
      right: 10px;

      i {
         color: #000;
         font-size: 14px;
      }
   }

   select {
      width: 100%;
      -moz-appearance: none;
      option {
         margin: 40px;
         // background: rgba(0, 0, 0, 0.3);
         // color: #fff;
         // text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
      }
   }
}

// swiper style
.swiper-button-prev,
.swiper-button-next {
   top: 43%;
}
.swiper-button-prev {
   left: 5px;
}
.swiper-button-next {
   right: 10px;
}
.circular-button {
   border-radius: 50%;
   background-color: #ffffff;
   color: #000;
   box-shadow: 0 8px 10px 0 rgba(62, 57, 107, 0.13);
}
</style>

<style lang="scss" scoped>
.logo-container .cutomer-logo-accuweather {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -91px;
}
.logo-container .cutomer-logo-actuate {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -91px;
}
.logo-container .cutomer-logo-admob {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -182px;
}
.logo-container .cutomer-logo-adobe {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -182px;
}
.logo-container .cutomer-logo-advanced-micro-devices {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -0px;
}
.logo-container .cutomer-logo-aerospace-corp {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -91px;
}
.logo-container .cutomer-logo-akamai {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -182px;
}
.logo-container .cutomer-logo-american-electric-power {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -273px;
}
.logo-container .cutomer-logo-american-express-company {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -273px;
}
.logo-container .cutomer-logo-apple {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -273px;
}
.logo-container .cutomer-logo-arcsight {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -364px;
}
.logo-container .cutomer-logo-ariba {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -364px;
}
.logo-container .cutomer-logo-arizona-state-university {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -364px;
}
.logo-container .cutomer-logo-ask {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -0px;
}
.logo-container .cutomer-logo-astrazeneca {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -91px;
}
.logo-container .cutomer-logo-at-t {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -182px;
}
.logo-container .cutomer-logo-atlassian-software {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -273px;
}
.logo-container .cutomer-logo-autodesk {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -364px;
}
.logo-container .cutomer-logo-avaya {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -455px;
}
.logo-container .cutomer-logo-axis-bank-ltd {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -455px;
}
.logo-container .cutomer-logo-bank-of-america {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -455px;
}
.logo-container .cutomer-logo-bank-of-ireland {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -455px;
}
.logo-container .cutomer-logo-bank-of-korea {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -546px;
}
.logo-container .cutomer-logo-bankinter {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -546px;
}
.logo-container .cutomer-logo-barclays {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -546px;
}
.logo-container .cutomer-logo-basf {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -546px;
}
.logo-container .cutomer-logo-bausch-lomb {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -0px;
}
.logo-container .cutomer-logo-bell-helicopter {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -91px;
}
.logo-container .cutomer-logo-bhp-billiton {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -182px;
}
.logo-container .cutomer-logo-blackboard {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -273px;
}
.logo-container .cutomer-logo-bnp-paribas {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -364px;
}
.logo-container .cutomer-logo-bristol-myers-squibb {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -455px;
}
.logo-container .cutomer-logo-british-gas-business {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -546px;
}
.logo-container .cutomer-logo-bskyb {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -637px;
}
.logo-container .cutomer-logo-bureau-of-economic-analysis {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -637px;
}
.logo-container .cutomer-logo-bureau-of-the-census {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -637px;
}
.logo-container .cutomer-logo-ca {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -637px;
}
.logo-container .cutomer-logo-cable-wireless-international {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -637px;
}
.logo-container .cutomer-logo-california-dept-of-food-and-agriculture {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -728px;
}
.logo-container .cutomer-logo-cancer-council-queensland {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -728px;
}
.logo-container .cutomer-logo-capgemini {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -728px;
}
.logo-container .cutomer-logo-carnegie-mellon-university {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -728px;
}
.logo-container .cutomer-logo-cb-richard-ellis {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -728px;
}
.logo-container .cutomer-logo-celequest {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -0px;
}
.logo-container .cutomer-logo-china-development-bank {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -91px;
}
.logo-container .cutomer-logo-china-mobile {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -182px;
}
.logo-container .cutomer-logo-cisco {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -273px;
}
.logo-container .cutomer-logo-citibank {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -364px;
}
.logo-container .cutomer-logo-clicktale {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -455px;
}
.logo-container .cutomer-logo-cnbc {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -546px;
}
.logo-container .cutomer-logo-cnet-com {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -637px;
}
.logo-container .cutomer-logo-cognizant {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -728px;
}
.logo-container .cutomer-logo-columbus-state-university {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -819px;
}
.logo-container .cutomer-logo-compuware {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -819px;
}
.logo-container .cutomer-logo-daimler-chrysler-uk {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -819px;
}
.logo-container .cutomer-logo-deloitte {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -819px;
}
.logo-container .cutomer-logo-denver-post {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -819px;
}
.logo-container .cutomer-logo-department-of-water-resources {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -819px;
}
.logo-container .cutomer-logo-deutsche-bank {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -910px;
}
.logo-container .cutomer-logo-dhl {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -910px;
}
.logo-container .cutomer-logo-disney {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -910px;
}
.logo-container .cutomer-logo-dunn-bradstreet {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -910px;
}
.logo-container .cutomer-logo-ebay {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -910px;
}
.logo-container .cutomer-logo-eclac-united-nations {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -910px;
}
.logo-container .cutomer-logo-edge-logistics {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -0px;
}
.logo-container .cutomer-logo-emc {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -91px;
}
.logo-container .cutomer-logo-emerson {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -182px;
}
.logo-container .cutomer-logo-emi-music {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -273px;
}
.logo-container .cutomer-logo-emirates-airline {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -364px;
}
.logo-container .cutomer-logo-ernst-young {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -455px;
}
.logo-container .cutomer-logo-expedia {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -546px;
}
.logo-container .cutomer-logo-exxonmobil {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -637px;
}
.logo-container .cutomer-logo-facebook {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -728px;
}
.logo-container .cutomer-logo-federal-bureau-of-investigation {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -819px;
}
.logo-container .cutomer-logo-federal-reserve-bank-of-cleveland {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -910px;
}
.logo-container .cutomer-logo-fedex {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -1001px;
}
.logo-container .cutomer-logo-fiat {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -1001px;
}
.logo-container .cutomer-logo-fidelity-investments {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -1001px;
}
.logo-container .cutomer-logo-fiserv {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -1001px;
}
.logo-container .cutomer-logo-florida-department-of-financial-services {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -1001px;
}
.logo-container .cutomer-logo-ford-motor {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -1001px;
}
.logo-container .cutomer-logo-fox-interactive-media {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -1001px;
}
.logo-container .cutomer-logo-gates-corporation {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -1092px;
}
.logo-container .cutomer-logo-ge-real-estate {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -1092px;
}
.logo-container .cutomer-logo-ge {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -1092px;
}
.logo-container .cutomer-logo-georgia-institute-of-technology {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -1092px;
}
.logo-container .cutomer-logo-glaxo-smith-kline {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -1092px;
}
.logo-container .cutomer-logo-godaddy {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -1092px;
}
.logo-container .cutomer-logo-goldman-sachs {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -1092px;
}
.logo-container .cutomer-logo-google-docs {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -0px;
}
.logo-container .cutomer-logo-google {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -91px;
}
.logo-container .cutomer-logo-hansen-group-gmbh {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -182px;
}
.logo-container .cutomer-logo-harvard-university {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -273px;
}
.logo-container .cutomer-logo-hdfc-bank-ltd {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -364px;
}
.logo-container .cutomer-logo-hellmann-worldwide-logistics {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -455px;
}
.logo-container .cutomer-logo-homeland-security-science-technology {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -546px;
}
.logo-container .cutomer-logo-honda {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -637px;
}
.logo-container .cutomer-logo-honeywell {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -728px;
}
.logo-container .cutomer-logo-hp {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -819px;
}
.logo-container .cutomer-logo-hsbc {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -910px;
}
.logo-container .cutomer-logo-huawei-technologies {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -1001px;
}
.logo-container .cutomer-logo-hubspot {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -1092px;
}
.logo-container .cutomer-logo-hughes-network {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -1183px;
}
.logo-container .cutomer-logo-hyundai {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -1183px;
}
.logo-container .cutomer-logo-ibm {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -1183px;
}
.logo-container .cutomer-logo-idaho-power-company {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -1183px;
}
.logo-container .cutomer-logo-ids-logistics {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -1183px;
}
.logo-container .cutomer-logo-inc {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -1183px;
}
.logo-container .cutomer-logo-indiana-university {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -1183px;
}
.logo-container .cutomer-logo-infosys {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -1183px;
}
.logo-container .cutomer-logo-ing-life-insurance {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -1274px;
}
.logo-container .cutomer-logo-intel {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -1274px;
}
.logo-container .cutomer-logo-interpol {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -1274px;
}
.logo-container .cutomer-logo-intuit {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -1274px;
}
.logo-container .cutomer-logo-ipc-logistics {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -1274px;
}
.logo-container .cutomer-logo-jaspersoft {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -1274px;
}
.logo-container .cutomer-logo-jda-software {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -1274px;
}
.logo-container .cutomer-logo-john-deere {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -1274px;
}
.logo-container .cutomer-logo-johnson-space-center {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -0px;
}
.logo-container .cutomer-logo-jones-lang-lasalle {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -91px;
}
.logo-container .cutomer-logo-jp-morgan {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -182px;
}
.logo-container .cutomer-logo-korean-air {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -273px;
}
.logo-container .cutomer-logo-kpmg {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -364px;
}
.logo-container .cutomer-logo-kraft-foods-sony {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -455px;
}
.logo-container .cutomer-logo-kraft-foods {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -546px;
}
.logo-container .cutomer-logo-l-t-infotech {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -637px;
}
.logo-container .cutomer-logo-lenovo {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -728px;
}
.logo-container .cutomer-logo-linkedin {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -819px;
}
.logo-container .cutomer-logo-lockheed-martin {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -910px;
}
.logo-container .cutomer-logo-logixml {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -1001px;
}
.logo-container .cutomer-logo-london-stock-exchange {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -1092px;
}
.logo-container .cutomer-logo-loreal {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -1183px;
}
.logo-container .cutomer-logo-madison-gas-and-electric-co {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -0px;
}
.logo-container .cutomer-logo-market-insight-corp {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -1365px;
}
.logo-container .cutomer-logo-massachusetts-institute-of-technology {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -1365px;
}
.logo-container .cutomer-logo-mcdonald-s {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -1365px;
}
.logo-container .cutomer-logo-mckinsey-co {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -1365px;
}
.logo-container .cutomer-logo-mercer {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -1365px;
}
.logo-container .cutomer-logo-metlife-insurance {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -1365px;
}
.logo-container .cutomer-logo-microsoft {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -1365px;
}
.logo-container .cutomer-logo-moneycontrol {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -1365px;
}
.logo-container .cutomer-logo-moody-s-analytics {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -1365px;
}
.logo-container .cutomer-logo-motorola {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -1456px;
}
.logo-container .cutomer-logo-nasa {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -1456px;
}
.logo-container .cutomer-logo-national-commercial-bank {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -1456px;
}
.logo-container .cutomer-logo-nbc-universal {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -1456px;
}
.logo-container .cutomer-logo-netapp {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -1456px;
}
.logo-container .cutomer-logo-network-solutions {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -1456px;
}
.logo-container .cutomer-logo-nielsen-company {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -1456px;
}
.logo-container .cutomer-logo-nike {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -1456px;
}
.logo-container .cutomer-logo-nikon {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -1456px;
}
.logo-container .cutomer-logo-nissan {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -0px;
}
.logo-container .cutomer-logo-nokia {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -91px;
}
.logo-container .cutomer-logo-nortel-networks {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -182px;
}
.logo-container .cutomer-logo-northrop-grumman {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -273px;
}
.logo-container .cutomer-logo-novartis {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -364px;
}
.logo-container .cutomer-logo-novell {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -455px;
}
.logo-container .cutomer-logo-office-depot-uk-ltd {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -546px;
}
.logo-container .cutomer-logo-ohio-state-university {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -637px;
}
.logo-container .cutomer-logo-oracle {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -728px;
}
.logo-container .cutomer-logo-paypal-europe {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -819px;
}
.logo-container .cutomer-logo-pearson {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -910px;
}
.logo-container .cutomer-logo-perot-systems {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -1001px;
}
.logo-container .cutomer-logo-petrobras {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -1092px;
}
.logo-container .cutomer-logo-pfizer {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -1183px;
}
.logo-container .cutomer-logo-philips-medical-systems {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -1274px;
}
.logo-container .cutomer-logo-philips {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -1365px;
}
.logo-container .cutomer-logo-pitney-bowes {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -1456px;
}
.logo-container .cutomer-logo-portugal-telecom {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -1547px;
}
.logo-container .cutomer-logo-pricewaterhousecoopers {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -1547px;
}
.logo-container .cutomer-logo-prime-home-builders {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -1547px;
}
.logo-container .cutomer-logo-progress-software {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -1547px;
}
.logo-container .cutomer-logo-purdue-university {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -1547px;
}
.logo-container .cutomer-logo-qualcomm {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -1547px;
}
.logo-container .cutomer-logo-queensland-police-service {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -1547px;
}
.logo-container .cutomer-logo-quepasa {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -1547px;
}
.logo-container .cutomer-logo-quest-software {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -1547px;
}
.logo-container .cutomer-logo-raytheon {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -1547px;
}
.logo-container .cutomer-logo-rediff-com {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -1638px;
}
.logo-container .cutomer-logo-renren {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -1638px;
}
.logo-container .cutomer-logo-research-in-motion {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -1638px;
}
.logo-container .cutomer-logo-rolex {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -1638px;
}
.logo-container .cutomer-logo-rsa-security {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -1638px;
}
.logo-container .cutomer-logo-sage-software {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -1638px;
}
.logo-container .cutomer-logo-salesforce {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -1638px;
}
.logo-container .cutomer-logo-samsung-medical-center {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -1638px;
}
.logo-container .cutomer-logo-samsung-total-petrochemicals-co-ltd {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -1638px;
}
.logo-container .cutomer-logo-san-diego-blood-bank {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -1638px;
}
.logo-container .cutomer-logo-saudi-aramco {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -0px;
}
.logo-container .cutomer-logo-saudi-telecom {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -91px;
}
.logo-container .cutomer-logo-schlumberger {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -182px;
}
.logo-container .cutomer-logo-select-property-group-ltd {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -273px;
}
.logo-container .cutomer-logo-shell-uk {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -364px;
}
.logo-container .cutomer-logo-siemens-building-technologies {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -455px;
}
.logo-container .cutomer-logo-siemens {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -546px;
}
.logo-container .cutomer-logo-sony-ericsson-mobile-communications {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -637px;
}
.logo-container .cutomer-logo-sony {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -728px;
}
.logo-container .cutomer-logo-sonybmg-music-entertainment {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -819px;
}
.logo-container .cutomer-logo-southwest-airlines {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -910px;
}
.logo-container .cutomer-logo-sprint-nextel {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -1001px;
}
.logo-container .cutomer-logo-standard-poor-s {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -1092px;
}
.logo-container .cutomer-logo-stanford-university {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -1183px;
}
.logo-container .cutomer-logo-state-farm-insurance {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -1274px;
}
.logo-container .cutomer-logo-summit-media {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -1365px;
}
.logo-container .cutomer-logo-sun-microsystems {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -1456px;
}
.logo-container .cutomer-logo-sungard {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -1547px;
}
.logo-container .cutomer-logo-symantec {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -1638px;
}
.logo-container .cutomer-logo-t-mobile {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -1729px;
}
.logo-container .cutomer-logo-tata-steel {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -1729px;
}
.logo-container .cutomer-logo-telecom-italia {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -1729px;
}
.logo-container .cutomer-logo-telenor {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -1729px;
}
.logo-container .cutomer-logo-texas-instruments {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -1729px;
}
.logo-container .cutomer-logo-the-boeing-company {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -1729px;
}
.logo-container .cutomer-logo-the-coca-cola-company {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -1729px;
}
.logo-container .cutomer-logo-the-motley-fool {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -1729px;
}
.logo-container .cutomer-logo-the-royal-bank-of-scotland {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -1729px;
}
.logo-container .cutomer-logo-the-university-of-wisconsin-madison {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -1729px;
}
.logo-container .cutomer-logo-the-weather-channel-interactive {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -1729px;
}
.logo-container .cutomer-logo-the-weather-network {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -0px;
}
.logo-container .cutomer-logo-the-world-bank {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -91px;
}
.logo-container .cutomer-logo-thompson-reuters {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -182px;
}
.logo-container .cutomer-logo-thyssenkrupp-steel-ag {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -273px;
}
.logo-container .cutomer-logo-tibco {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -364px;
}
.logo-container .cutomer-logo-time-warner-cable {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -455px;
}
.logo-container .cutomer-logo-toyota-trasportation {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -546px;
}
.logo-container .cutomer-logo-trend-micro {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -637px;
}
.logo-container .cutomer-logo-ubs-ag {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -728px;
}
.logo-container .cutomer-logo-uc-berkeley-graduate-school-of-journalism {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -819px;
}
.logo-container .cutomer-logo-united-airlines {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -910px;
}
.logo-container .cutomer-logo-united-nations-office {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -1001px;
}
.logo-container .cutomer-logo-university-of-california {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -1092px;
}
.logo-container .cutomer-logo-university-of-colorado {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -1183px;
}
.logo-container .cutomer-logo-university-of-manchester {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -1274px;
}
.logo-container .cutomer-logo-university-of-notre-dame {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -1365px;
}
.logo-container .cutomer-logo-university-of-pittsburgh {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -1456px;
}
.logo-container .cutomer-logo-university-of-warwick {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -1547px;
}
.logo-container .cutomer-logo-us-air-force {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -1638px;
}
.logo-container .cutomer-logo-us-army-us-postal-service {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -1729px;
}
.logo-container .cutomer-logo-us-border-patrol {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -1820px;
}
.logo-container .cutomer-logo-us-department-of-energy {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -1820px;
}
.logo-container .cutomer-logo-us-department-of-treasury {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -1820px;
}
.logo-container .cutomer-logo-us-environmental-protection-agency {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -1820px;
}
.logo-container .cutomer-logo-us-geological-survey {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -1820px;
}
.logo-container .cutomer-logo-us-government-accountability-office {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -1820px;
}
.logo-container .cutomer-logo-us-navy {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -1820px;
}
.logo-container .cutomer-logo-us-social-security-administration {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -1820px;
}
.logo-container .cutomer-logo-verisign {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -1820px;
}
.logo-container .cutomer-logo-verizon-wireless {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -1820px;
}
.logo-container .cutomer-logo-vmware {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -1820px;
}
.logo-container .cutomer-logo-vodafone {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -1820px;
}
.logo-container .cutomer-logo-volvo {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -0px -1911px;
}
.logo-container .cutomer-logo-w3optimizer-com {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -173px -1911px;
}
.logo-container .cutomer-logo-wal-mart {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -346px -1911px;
}
.logo-container .cutomer-logo-watson-wyatt-uk- {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -519px -1911px;
}
.logo-container .cutomer-logo-watson-wyatt-uk {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -692px -1911px;
}
.logo-container .cutomer-logo-weather-com {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -865px -1911px;
}
.logo-container .cutomer-logo-wells-fargo-bank {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1038px -1911px;
}
.logo-container .cutomer-logo-west-herr-automotive-group {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1211px -1911px;
}
.logo-container .cutomer-logo-wikinvest {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1384px -1911px;
}
.logo-container .cutomer-logo-wipro {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1557px -1911px;
}
.logo-container .cutomer-logo-world-energy-council {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1730px -1911px;
}
.logo-container .cutomer-logo-wufoo {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -1903px -1911px;
}
.logo-container .cutomer-logo-xerox {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -2076px -0px;
}
.logo-container .cutomer-logo-yahoo {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -2076px -91px;
}
.logo-container .cutomer-logo-yelp-com {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -2076px -182px;
}
.logo-container .cutomer-logo-yodlee {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -2076px -273px;
}
.logo-container .cutomer-logo-zoho {
   background-image: url('/public/images/customers-logo-sprite.png');
   background-position: -2076px -364px;
}
</style>
